import React, {ReactElement, useContext, useEffect, useState} from "react";
import SwaggerUI from "swagger-ui-react";
import appStyle from "../../style.less";
import "swagger-ui-react/swagger-ui.css";
import {getSwagger} from "@yaak/components/services/api/api";
import {ToastContext, ToastContextType} from "@yaak/components/context/toastContext";

type SwaggerPageProps = {
  token: string
}


const SwaggerPage: React.FunctionComponent<SwaggerPageProps> = ({
  token,
}): ReactElement => {
  const { setShowToast } = useContext(ToastContext) as ToastContextType
  const [swaggerContent, setSwaggerContent] = useState<string>()
  useEffect(() => {
    const fetchSwagger = async () => {
      const swaggerContent = await getSwagger({
        token,
        onAlert: setShowToast
      })
      setSwaggerContent(swaggerContent)
    }

    token && fetchSwagger()
  }, [token])

  return (
    <div className={appStyle.page}>
      {swaggerContent ? (
        <SwaggerUI spec={swaggerContent} />
      ) : (
        <p>Loading Swagger documentation...</p>
      )}
    </div>
  )
}

export default SwaggerPage;
